module.exports = __webpack_public_path__ + "img/rabt.080dd424.jpg";